import { render, staticRenderFns } from "./color-simple.vue?vue&type=template&id=ea52ca26&scoped=true"
import script from "./color-simple.vue?vue&type=script&lang=js"
export * from "./color-simple.vue?vue&type=script&lang=js"
import style0 from "./color-simple.vue?vue&type=style&index=0&id=ea52ca26&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea52ca26",
  null
  
)

export default component.exports